
'use client';

import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ScanLine } from 'lucide-react';

interface UrlInputFormProps {
  // The action to be performed when the form is submitted.
  // This should be the function returned by useActionState's tuple.
  formAction: (payload: FormData) => void;
  isPending: boolean;
}

export function UrlInputForm({ formAction, isPending }: UrlInputFormProps) {
  // No longer need a manual handleSubmit.
  // The form's `action` prop will handle calling the server action.
  return (
    <form action={formAction} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="url" className="text-lg font-medium">Website URL</Label>
        <Input
          id="url"
          name="url"
          type="url"
          placeholder="https://example.com"
          required
          className="text-base"
          disabled={isPending}
        />
      </div>
      <Button type="submit" className="w-full sm:w-auto" disabled={isPending}>
        <ScanLine className="mr-2 h-5 w-5" />
        {isPending ? 'Analyzing...' : 'Analyze Website'}
      </Button>
    </form>
  );
}
